var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.134,
    height: 15.134,
    viewBox: "0 0 15.134 15.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7895",
    "data-name": "Path 7895",
    d: "M7.557,15.133A7.567,7.567,0,1,1,15.134,7.58,7.556,7.556,0,0,1,7.557,15.133Zm.767-9.782V3.861a1.049,1.049,0,0,0-.033-.3.758.758,0,0,0-.819-.535.748.748,0,0,0-.653.762c0,1.254,0,2.508,0,3.762a.765.765,0,0,0,.459.719c.369.185.738.369,1.112.554.62.308,1.235.625,1.855.928a.755.755,0,0,0,1.112-.592.763.763,0,0,0-.459-.771q-1.207-.61-2.423-1.211a.222.222,0,0,1-.147-.241C8.324,6.407,8.324,5.877,8.324,5.351Z",
    transform: "translate(0 0.001)",
    fill: "#3177be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockService);
export default __webpack_public_path__ + "static/media/clock-service.7cfd852225ff076c521f98d3ff71375f.svg";
export { ForwardRef as ReactComponent };